module.exports = __webpack_public_path__ + "static/media/inetcpl_1321.b02edd96.ico";